module.exports = __webpack_public_path__ + "img/lussekatt.8afbfa44.png";